// @flow
import React from 'react';
import i18n from 'i18n-js';

import Button from '../Button';
import Popup from '../Popup';
import PopupContainer from '../PopupContainer';
import PopupHeader from '../PopupHeader';
import PopupContent from '../PopupContent';
import PopupHeaderLeftGroup from '../PopupHeaderLeftGroup';
import PopupHeaderTitle from '../PopupHeaderTitle';
import PopupFooter from '../PopupFooter';

type PopupConfirmationsType = {
  id: string,
  title?: string,
  size?: string,
  children: any,
  onCancel: Function,
  onConfirm: Function,
}

const PopupConfirmations = ({
  id,
  children,
  size = 'medium',
  title,
  onCancel,
  onConfirm,
}: PopupConfirmationsType) => (
  <Popup
    id={id}
    transitionType="slideDown"
    transitionMs={600}
  >
    <PopupContainer size={size}>
      { title
        && (
          <PopupHeader>
            <PopupHeaderLeftGroup>
              <PopupHeaderTitle title={title} />
            </PopupHeaderLeftGroup>
          </PopupHeader>
        )
      }
      <PopupContent isContrasted>
        { children }
      </PopupContent>
      <PopupFooter>
        <Button
          tint="secondary"
          title={i18n.t('buttons.cancel')}
          onClick={() => onCancel()}
        />
        <Button
          tint="error"
          title={i18n.t('buttons.accept')}
          onClick={() => onConfirm()}
        />
      </PopupFooter>
    </PopupContainer>
  </Popup>
);

export default PopupConfirmations;



// WEBPACK FOOTER //
// ./src/scripts/components/PopupConfirmations/index.jsx